import { type PropsWithChildren } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryProvider } from '@app/providers/QueryProvider';
import { AntdThemeProvider } from '@app/providers/AntdThemeProvider';

export const AppProviders = ({ children }: PropsWithChildren) => (
  <QueryProvider>
    <AntdThemeProvider>
      <BrowserRouter>{children}</BrowserRouter>
    </AntdThemeProvider>
  </QueryProvider>
);
